<template>
  <div class="block info-data">
    <h2><i class="sr-icon-box-shield"></i><span v-html="heading"></span></h2>
    <p v-if="autoSsl" v-html="info"></p>
    <div v-else v-html="info"></div>
  </div>
</template>

<script>
  export default {
    name: "InfoData",
    props: {
      testSsl: { type: Object },
      autoSsl: { type: String }
    },
    computed: {
      heading() {
        return this.autoSsl ? this.$t('infoData.sslAuto', { domain: this.autoSsl }) : this.$t('infoData.sslTest', { days: 10, domain: 'name' })
      },
      info() {
        return this.autoSsl ? this.$t('infoData.sslAutoDetails') : this.$t('infoData.sslTestDetails', { days: this.testSsl.days })
      }
    }
  }
</script>

<style lang="scss">
  .info-data {
    border: 1px solid $green;

    h2 {
      font-size: 19px;
      color: $green;
      margin-bottom: 27px;
      padding-left: 44px;
      position: relative;
      letter-spacing: -.05px;

      i {
        font-size: 36px;
        position: absolute;
        top: -4px;
        left: 0;
      }
    }

    p:last-child {
      margin-bottom: 0;
    }
  }
</style>
